/**
 * Created by zzy on 2019/8/7.
 */
import XdhDeviceMap from './XdhDeviceMap.vue'
export default XdhDeviceMap



// WEBPACK FOOTER //
// ./src/views/monitoring/xdhDeviceMap/index.js